export const AlignBottomIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" height="16" width="16" fill="none">
    <path
      d="M1.3335 14.6654V13.332H14.6668V14.6654H1.3335ZM4.66683 11.9987V1.33203H6.66683V11.9987H4.66683ZM9.3335 11.9987V5.33203H11.3335V11.9987H9.3335Z"
      fill="currentColor"
    />
  </svg>
);
